import { apiClient } from "../../../api/client";
import * as ActionType from "./seller.type";
import { setToast } from "../../../util/toast";

const normalizeError = (error) => ({
  message: error?.message || "Request failed",
  code: error?.code || "UNKNOWN",
  details: error?.details || {},
});

// GET SELLER
export const getSeller = (start, limit) => async (dispatch) => {
  dispatch({ type: ActionType.GET_SELLER_REQUEST });
  const res = await apiClient.get(`seller/getRealSeller?start=${start}&limit=${limit}`);
  if (res.ok) {
    dispatch({ type: ActionType.GET_SELLER_SUCCESS });
    dispatch({
      type: ActionType.GET_SELLER,
      payload: res.data?.sellers,
      totalSeller: res.data?.totalSellers,
    });
  } else {
    dispatch({
      type: ActionType.GET_SELLER_FAILURE,
      payload: normalizeError(res),
    });
    console.error(res.message);
  }
};

export const sellerDropDown = () => async (dispatch) => {
  const res = await apiClient.get("seller/getSellerAddedByAdmin");
  if (res.ok) {
    dispatch({
      type: ActionType.GET_SELLER_DROP_DOWN,
      payload: res.data?.seller,
    });
  } else {
    console.error(res.message);
  }
};

// SELLER BLOCK UNBLOCK
export const sellerIsBlock = (seller, block) => async (dispatch) => {
  const res = await apiClient.patch(`seller/blockUnblock?sellerId=${seller._id}`);
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.BLOCK_UNBLOCK_SELLER,
      payload: { data: res.data.seller, id: seller._id },
    });
    setToast(
      "success",
      `${seller.firstName} Is ${block === true ? "Blocked" : "Unblocked"} Successfully!`
    );
  } else {
    setToast("error", res.data?.message || res.message || "Seller Unblock Successfully !!");
  }
};

// CREATE SELLER
export const createSeller = (formData) => async (dispatch) => {
  const res = await apiClient.post("seller/createByAdmin", formData);
  if (res.ok && res.data?.status === true) {
    dispatch({ type: ActionType.CREATE_SELLER, payload: res.data.seller });
    setToast("success", "Seller  created Successfully !");
  } else if (!res.ok) {
    setToast("error", res.message);
  }
};

// UPDATE SELLER
export const updateSeller = (formData, id) => async (dispatch) => {
  const res = await apiClient.patch(`seller/update?sellerId=${id}`, formData);
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.UPDATE_SELLER,
      payload: { updateSeller: res.data.seller, id },
    });

    setToast("success", "Seller Updated Successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

// GET SELLER PROFILE
export const getSellerProfile = (id) => async (dispatch) => {
  dispatch({ type: ActionType.GET_SELLER_PROFILE_REQUEST });
  const res = await apiClient.get(`seller/getProfileByAdmin?sellerId=${id}`);
  if (res.ok) {
    dispatch({ type: ActionType.GET_SELLER_PROFILE_SUCCESS });
    dispatch({
      type: ActionType.GET_SELLER_PROFILE,
      payload: res.data?.seller,
    });
  } else {
    dispatch({
      type: ActionType.GET_SELLER_PROFILE_FAILURE,
      payload: normalizeError(res),
    });
    console.error(res.message);
  }
};

// SELLER ORDER
export const getSellerProduct = (sellerId) => async (dispatch) => {
  const res = await apiClient.get(`product/getSellerWise?sellerId=${sellerId}`);
  if (res.ok) {
    dispatch({
      type: ActionType.GET_SELLER_PRODUCT,
      payload: res.data?.product,
    });
  } else {
    console.error(res.message);
  }
};

// Get Seller Wallet
export const getSellerWallet = (sellerId) => async (dispatch) => {
  const res = await apiClient.get(`sellerWallet/getAllAmount?sellerId=${sellerId}`);
  if (res.ok) {
    dispatch({
      type: ActionType.GET_SELLER_WALLET,
      payload: res.data,
    });
  } else {
    console.error(res.message);
  }
};
// Get Seller Transition
export const getSellerTransition =
  (start, limit, startDate, endDate, sellerId, status) => async (dispatch) => {
    const res = await apiClient.get(
      `sellerWallet/retrieveSellerTransactions?start=${start}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&sellerId=${sellerId}&status=${status}`
    );
    if (res.ok) {
      dispatch({
        type: ActionType.GET_SELLER_TRANSITION,
        payload: res.data,
      });
    } else {
      console.error(res.message);
    }
  };
export const getSellerOrder =
  (sellerId, start, limit, status) => async (dispatch) => {
    const res = await apiClient.get(
      `order/ordersOfSeller?sellerId=${sellerId}&start=${start}&limit=${limit}&status=${status}`
    );
    if (res.ok) {
      dispatch({
        type: ActionType.GET_SELLER_ORDER,
        payload: res.data,
      });
    } else {
      console.error(res.message);
    }
  };
export const getSellerOrderDetail = (sellerId, orderId) => async (dispatch) => {
  const res = await apiClient.get(
    `order/orderForSeller?sellerId=${sellerId}&orderId=${orderId}`
  );
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.GET_SELLER_ORDER_DETAIL,
      payload: res.data?.order,
    });
  } else if (!res.ok) {
    console.error(res.message);
  }
};

// live seller
export const getLiveSeller = (start, limit) => async (dispatch) => {
  const res = await apiClient.get(`liveSeller/liveSellerList?start=${start}&limit=${limit}`);
  if (res.ok) {
    dispatch({
      type: ActionType.GET_LIVE_SELLER,
      payload: res.data?.liveSeller,
    });
  } else {
    console.error(res.message);
  }
};

export const getLiveSellerProduct = (sellerId) => async (dispatch) => {
  dispatch({ type: ActionType.GET_LIVE_SELLER_PRODUCT_REQUEST });
  const res = await apiClient.get(`product/selectedProducts?sellerId=${sellerId}`);
  if (res.ok) {
    dispatch({
      type: ActionType.GET_LIVE_SELLER_PRODUCT_SUCCESS,
      payload: res.data?.SelectedProducts,
    });
  } else {
    dispatch({ type: ActionType.GET_LIVE_SELLER_PRODUCT_FAILURE });
    console.error(res.message);
  }
};
